import userProfile from "@/public/assets/img/user-profile.png"
import Modal from "@/src/common/components/Modal"
import Button from "@/src/sb/components/Button"
import Image from "next/image"

type SuccessRequestProfileUpdateModalProps = {
  onClose?: () => void
  onUpdateProfile: () => void
}

const SuccessRequestProfileUpdateModal = ({
  onClose,
  onUpdateProfile
}: SuccessRequestProfileUpdateModalProps) => {
  return (
    <Modal onClose={onClose} className="md:max-w-[400px]">
      <div className="bg-white p-8 text-center space-y-4 max-w-[400px]">
        <div className="inline-block">
          <Image src={userProfile} alt="update" width={userProfile.width / 2} />
        </div>
        <h6 className="font-medium text-lg font-jakarta">
          Please update your profile
        </h6>
        <p className="font-jakarta text-gray-600">
          Please update your profile information to enable us to serve you
          better
        </p>
        <div>
          <Button type="secondary" onClick={onUpdateProfile}>
            Update profile
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SuccessRequestProfileUpdateModal
